import './tokens.css';
export default {
    "spacing-none": "0",
    "spacing-xxs": "4px",
    "spacing-xs": "8px",
    "spacing-sm": "12px",
    "spacing-md": "16px",
    "spacing-lg": "24px",
    "spacing-xl": "32px",
    "spacing-xxl": "40px"
};
